// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__gL2V_","emails":"CreateEditClinics_emails___q3rC","emailTagLabel":"CreateEditClinics_emailTagLabel___keZn"};